import React from 'react'
import './Ngemi.css'
import Navbar from '../body/navbar/Navb'

const Ngemi = () => {
  return (
    <div className='ngemi'>
        <Navbar/>
        <h5>NGEMI</h5>
        <h6>
          Thaayú mbarí ya nyamúgo, ici ní ngemi iria ciugagwo mwana aciarwo.
           Mwana wa kahíí ciake níciothe ithano no wa kairítu ní inya.
          
        </h6>
        <ul>
        
    <li>    1.  Úgo - úgí </li>
<li>2.  Úrathi - </li>
<li>3.  Úthamaki </li>
<li>4.  Útonga </li>
<li>5.  Úcamba - <p className='ucamba'>
   Ya úcamba ndiugagírwo wa kairítu níúndú írongoragírio 
           mwana wa kahíí akorwo na úcamba wa gúthií ita gútaha.
  </p></li>
  </ul>
    </div>
  )
}

export default Ngemi
